import { render } from "./default-page.vue?vue&type=template&id=67f9343c&scoped=true"
import script from "./default-page.vue?vue&type=script&lang=js"
export * from "./default-page.vue?vue&type=script&lang=js"

import "./default-page.vue?vue&type=style&index=0&id=67f9343c&scoped=true&lang=scss"
import "./default-page.vue?vue&type=style&index=1&id=67f9343c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f9343c"]])

export default __exports__